export default __webpack_public_path__ + "static/media/logo_cars_region.ef098690.png";